import { AnyAction, CombinedState, combineReducers } from '@reduxjs/toolkit';
import { PersistPartial } from 'redux-persist/es/persistReducer';
import { IAuthSlice, authReducer } from './auth/authSlice';
import { IUserSlice, userReducer } from './user/userSlice';
import { generalReducer, IGeneralSlice } from './general/generalSlice';
import { ISubscriptionSlice, subscriptionReducer } from './subscription/subscriptionSlice';
import { gemReducer, IGemSlice } from './gem/gemSlice';
import { IOrganizationSlice, organizationReducer } from './organization/organizationSlice';
import { IPaymentSlice, paymentReducer } from './payment/paymentSlice';
import { IInvoiceSlice, invoiceReducer } from './invoice/invoiceSlice';
import { ISubordinateSlice, subordinateReducer } from './subordinate/subordinateSlice';
import { IInviteSlice, inviteReducer } from './invite/inviteSlice';
import { IModelSlice, modelReducer } from './models/modelsSlice';
import { IWebsocketSlice, websocketReducer } from './webSocket/webSocketSlice';
import { gemGPTReducer, IGemGPTSlice } from './gemGPT/gemGPTslice';

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  general: generalReducer,
  subscription: subscriptionReducer,
  gem: gemReducer,
  organization: organizationReducer,
  payment: paymentReducer,
  invoice: invoiceReducer,
  subordinate: subordinateReducer,
  invite: inviteReducer,
  model: modelReducer,
  websocket: websocketReducer,
  gemGPT: gemGPTReducer,
});

const rootReducer = (
  state:
    | CombinedState<{
        auth: IAuthSlice & PersistPartial;
        user: IUserSlice;
        general: IGeneralSlice;
        subscription: ISubscriptionSlice;
        gem: IGemSlice;
        organization: IOrganizationSlice;
        payment: IPaymentSlice;
        invoice: IInvoiceSlice;
        subordinate: ISubordinateSlice;
        invite: IInviteSlice;
        model: IModelSlice;
        websocket: IWebsocketSlice;
        gemGPT: IGemGPTSlice;
      }>
    | undefined,
  action: AnyAction,
) => {
  if (action.type === 'CLEAR_STORE') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
